import {USER_ROLES} from "./users.models";

export type FILE_EXTENSION = 'pdf' | 'txt' | 'xlsx' | 'docx' | 'pptx' | 'rtf' | 'jpeg' | 'png' | 'unsupported' | 'error';

export const EXTENSION_TO_FILE_TYPE: Record<string, FILE_EXTENSION> = {
    txt: 'txt',
    pdf: 'pdf',
    xlsx: 'xlsx',
    xls: 'xlsx',
    docx: 'docx',
    doc: 'docx',
    pptx: 'pptx',
    ppt: 'pptx',
    jpeg: 'jpeg',
    jpg: 'jpeg',
    png: 'png',
    rtf: 'rtf',
};

export const FILE_TYPE_TO_MIME: Record<string, string> = {
    pdf: 'application/pdf',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    jpeg: 'image/jpeg',
    png: 'image/png',
    rtf: 'application/rtf',
};

export enum COLLECTION_TYPE {
    MANUAL = "MANUAL",
    AUTOMATIC = "AUTOMATIC",
    DEFAULT = "DEFAULT",
}

export const DEFEAULT_COLLECTIONS_SIZE = 10;

export interface DocumentData {
    id: number;
    name: string;
    fileName: string;
}

export interface SortType {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
    numberOfElements: number;
}

export interface PageableType {
    empty: boolean;
    sort: {
        sorted: boolean;
        unsorted: boolean;
    },
    paged: boolean;
    pageNumber: number;
    pageSize: number;
    unpaged: boolean;
}

export interface DocumentDataResponse {
    id: number;
    name: string;
    fileName: string;
    createdAt: string;
    conversationId: number;
    size: number;
    owner: {
        email: string;
    },
    extension: FILE_EXTENSION;
}

export interface DataSourceDocumentListResponse {
    totalElements: number;
    totalPages: number;
    first: boolean;
    last: boolean;
    size: number;
    content: DocumentDataResponse[];
    number: number;
    sort: SortType;
    offset: number;
    pageable: PageableType;
    empty: boolean;
}

export interface CollectionDataRequestParams {
    page: number;
    size: number;
    name?: string;
    isDefault?: boolean;
}

export interface CollectionDataContent {
    id: number;
    name: string,
    lastModificationDate: string;
    collectionType: COLLECTION_TYPE;
    amountOfDocuments: number;
    owner: {
        id: number;
        email: string;
        firstName: string;
        lastName: string;
        createdAt: string;
        role: USER_ROLES;
        activated: boolean;
        position: string;
        phoneNumber: string;
        isAdUser: boolean;
    },
    isDefault: boolean;
}

export interface CollectionDataResponse {
    content: CollectionDataContent[],
    totalElements: number;
    totalPages: number;
    first: boolean;
    last: boolean;
    size: number;
    number: number;
    sort: {
        empty: boolean;
        sorted: boolean;
        unsorted: boolean;
    },
    numberOfElements: number;
    pageable: {
        offset: number;
        sort: {
            empty: boolean;
            sorted: boolean;
            unsorted: boolean;
        },
        pageNumber: number;
        paged: boolean;
        pageSize: number;
        unpaged: boolean;
    },
    empty: boolean;
}

export interface UploadDocumentResponse {
    documentId: number;
}